module.exports = __webpack_public_path__ + "img/example_eforie_a2.4481b2db.jpg";